export default __webpack_public_path__ + "static/media/eb-ultra-wht-banner-2.14b4393b.jpg";